import axios from "axios";
import { SessionKey } from "../utils/app-config";
import ReCAPTCHA from "react-google-recaptcha";
import { postValidateRecaptcha } from "../api/apimethods";
import { ICaptchaRequest } from "../typings/interfaces/Requests/CaptchaRequest";
import appSettings from "../appsettings.json";

const { BaseUrl: baseURL, XApiKey: apiKey } = appSettings.ApiSettings;
// Store the recaptcha ref globally
let recaptchaRef: React.RefObject<ReCAPTCHA> | null = null;

export function setRecaptchaRef(ref: React.RefObject<ReCAPTCHA>) {
  recaptchaRef = ref;
}

export const API = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

API.interceptors.request.use(
  async (config) => {
    // Add X-API-KEY (hardcoded for all API calls)
    try {
      if (!config.headers) config.headers = {} as any;
      config.headers["x-api-key"] = apiKey;
    } catch (e) {
      // ignore
    }
    // Set Authorization dynamically from localStorage on each request
    try {
      const auth = localStorage.getItem(SessionKey.AuthToken) ?? "";
      if (!config.headers) config.headers = {} as any;
      config.headers["Authorization"] = `Bearer ${auth}`;
    } catch (e) {
      // ignore localStorage errors
    }
    const isPost = config.method?.toLowerCase() === "post";
    const isIgnored =
      config.url?.includes("/recaptcha/verify") ||
      config.url?.includes("/forget-password") ||
      config.url?.includes("/captivebredbirdsingleregistration") ||
      config.url?.includes("/captivebredbirdbulkregistration");

    // ✅ Skip for non-POSTs or ignored URLs
    if (!isPost || !isIgnored) return config;

    if (!recaptchaRef || !recaptchaRef.current) {
      console.warn("Missing reCAPTCHA ref");
      return config;
    }

    // Get token from reCAPTCHA
    const token = recaptchaRef.current?.getValue();
    if (!token) {
      throw new axios.Cancel("reCAPTCHA token missing — request cancelled.");
    }
     // ✅ Set token as header (custom header key example)    
    config.headers["X-Recaptcha-token"] =token;
    return config;
  },
  (error) => {
    // Any setup error
    return Promise.reject(error);
  }
);

const builder = {
  API,
};
export default builder;
